import { validateUrls } from "api/types"
import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"

const getPhoenixURL = getServiceURL(SERVICE_PREFIX.phoenix)

export const urls = validateUrls({
  slugs: productSlug =>
    getPhoenixURL(
      `/v1/credentials/enrollment-agreements/${productSlug}/slugs/`
    ),
  accept: () => getPhoenixURL(`/v1/credentials/enrollment-agreements/`),
})
